// extracted by mini-css-extract-plugin
module.exports = {"ApprovalBlock":"ApprovalModal-module__ApprovalBlock___1lq6f","ApprovalModal":"ApprovalModal-module__ApprovalModal___3CnX3","btn_menu":"ApprovalModal-module__btn_menu___2Cr5R"};